import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { playerBalanceLogStore, } from "../stores/playerBalanceLog";
import { useLocation } from "react-router-dom";
/* ------- */

class PlayerBalanceLog extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.Interface.loadPlayerBalanceLog("canceled");
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			setTimeout(() => {
				this.props.Interface.loadPlayerBalanceLog("canceled");
			}, 0);
		}
	};

	handleInputDebounceChange = (input) => {
		this.props.setPlayerBalanceLog({ ...this.props.playerBalanceLog, currentSearch: input.detail.value, pagination: {
				...this.props.playerBalanceLog.pagination,
				current: 1,
	 }});


		if (input.detail.value.length === 0) {
			setTimeout(() => this.props.Interface.loadPlayerBalanceLog("canceled"), 250)
		}

	};


	render() {
		return (
			<>
				{this.props.playerBalanceLog.loaded && this.props.playerBalanceLog.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.playerBalanceLog.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.playerBalanceLog.error.code} | request timestamp: {this.props.playerBalanceLog.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.playerBalanceLog.loaded}
					sortingColumn={{ sortingField: this.props.playerBalanceLog.sorting.sortingColumn.column }}
					sortingDescending={this.props.playerBalanceLog.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setPlayerBalanceLog({ ...this.props.playerBalanceLog, sorting: {
								...this.props.playerBalanceLog.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField
								},
								isDescending: sorting.detail.isDescending,
							} });

						setTimeout(() => {
							this.props.Interface.loadPlayerBalanceLog("canceled");
						}, 250);
					}}
					columnDefinitions={[
						{ id: "uid", header: "UID", sortingField: false, cell: (item) => JSON.parse(item.request).uid },
						{ id: "amount", header: "Amount", sortingField: false, cell: (item) => JSON.parse(item.request).amount },
						{ id: "user", header: "User", sortingField: false, cell: (item) => JSON.parse(item.request).user },
						{ id: "reason", header: "Reason", sortingField: false, cell: (item) => JSON.parse(item.request).reason },
						{ id: "brand", header: "Brand", sortingField: false, cell: (item) => item.brand },
						{ id: "ip", header: "Ip", sortingField: false, cell: (item) => item.ip },
						{ id: "date", header: "Date", sortingField: "date", cell: (item) => <>{new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString()}</> },
					]}
					items={this.props.playerBalanceLog.data}
					pagination={
						<Pagination
							disabled={!this.props.playerBalanceLog.loaded}
							currentPageIndex={this.props.playerBalanceLog.pagination.current}
							pagesCount={this.props.playerBalanceLog.pagination.total}
							onChange={(page) => {
								this.props.setPlayerBalanceLog({ ...this.props.playerBalanceLog, pagination: { ...this.props.playerBalanceLog.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => this.props.Interface.loadPlayerBalanceLog(), 250);
							}}
						/>
					}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Logs per page", options: this.props.config.playerBalanceLog.preferences.perPage }}
							preferences={{ pageSize: this.props.config.playerBalanceLog.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("playerBalanceLog.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, playerBalanceLog: { ...this.props.config.playerBalanceLog, perPage: preferences.detail.pageSize } });

								setTimeout(() => this.props.Interface.loadplayerBalanceLog(), 250);
							}}
						/>
					}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
									children={
										<>
											<Input
												disabled={!this.props.playerBalanceLog.loaded}
												onKeyDown={this.handleKeyPress}
												disableBrowserAutocorrect={true}
												placeholder="UID, User, Amount"
												inputMode="search"
												type="search"
												value={this.props.playerBalanceLog.currentSearch}
												onChange={this.handleInputDebounceChange}
											/>
										</>
									}
								/>
							}
						/>
					}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Player balance log"
									counter={
										<>
											(
											{
												this.props.playerBalanceLog.pagination.count
											}
											)
										</>
									}
								/>
							}
						/>
					}
					empty="No player balance log found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const playerBalanceLog = useRecoilValue(playerBalanceLogStore);
		const setPlayerBalanceLog = useSetRecoilState(playerBalanceLogStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		return <Component {...props}  playerBalanceLog={playerBalanceLog} setPlayerBalanceLog={setPlayerBalanceLog} config={config} setConfig={setConfig}  />;
	};
}

export default withRecoil(PlayerBalanceLog);
